<template>
	<nut-navbar
		class="navbar"
		title="抽奖游戏介绍"
		fixed
		:placeholder="false"
		leftShow
		@on-click-back="goBack"
	></nut-navbar>
	<article class="article">
		<p>
			线下门店推广运营的利器，神器来啦~~
			多动屏不仅可发布图片，视频，PPT等各种文件进行展示，还可发布“大转盘抽奖游戏”，可有效辅助门店提升现场气氛，吸引新客户参与，提升老客户回头率（老客户可能会兑奖消费），最关键的是，我们可以获得本次活动的大数据报表：<br />1.
			以往所有活动源数据；<br />2. 中奖纪录源数据；<br />3.
			顾客信息源数据。
		</p>
		<p>引流就是如此简单，好好利用起来吧~</p>
		<p>
			发布一个大转盘促销游戏，只需打开“多动屏”即刻编辑发布，如下请查看截图；
		</p>
		<h3>1. 打开首页上“抽奖游戏”</h3>
		<img
			src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/u8.jpg"
		/>
		<h3>
			2.
			进入抽奖配置界面填写抽奖内容（都需要填写哦~如有疑惑，可点击查看右上角的
			“？”），如下图所示；
		</h3>
		<img
			src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/u14.png"
		/>
		<h3>
			3.
			促销游戏列表页，发布之后的促销游戏都将在“播放内容/游戏”下统一展示。
		</h3>
		<img
			src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/u16.png"
		/>
		<h3>4. 大招在后面哦~ 促销游戏的源数据信息有三种形式，请查看下图：</h3>
		<p>顾客信息数据信息</p>
		<img
			src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/u24.png"
		/>
		<p>中奖纪录数据信息</p>
		<img
			src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/u24.png"
		/>
		<p>以往促销游戏数据信息</p>
		<img
			src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/u24.png"
		/>
	</article>
</template>

<script>
import useNavigate from '@/hooks/useNavigate';
export default {
	name: 'LottertIntroduction',
	setup() {
		const { goBack } = useNavigate();
		return { goBack };
	},
};
</script>

<style lang="scss" scoped>
.article {
	margin-top: $navbar-height;
	box-sizing: border-box;
	padding: 20px 15px;
	font-size: 14px;
	line-height: 24px;
	* {
		width: 100%;
	}
	h3 {
		font-weight: 400;
		margin-bottom: 0.34em;
	}
	p {
		margin: 0 0 0.8em;
	}
}
</style>
